import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);


// 登录验证
export default new Vuex.Store({
  state: {
    user: ""
  },
  mutations: {
    // 登录
    login(state, user) {
      state.user = user;
      localStorage.setItem("userInfo", JSON.stringify(user));
    },
    // 退出
    logout(state) {
      localStorage.removeItem("userInfo");
      state.user = null;
    },
    setUserInfo(state, user) {
      state.user = user;
      localStorage.setItem("userInfo",JSON.stringify(user));
    }

  }, getters: {

    getUserInfo: state => {

      if (state.user == null || state.user == "") {
        state.user = JSON.parse(localStorage.getItem("userInfo"));
      }
      return state.user;
    }

  }
})



// WEBPACK FOOTER //
// ./src/vuex/store.js